module.exports = __webpack_public_path__ + "static/media/logo-light.594b90d3.svg";